import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import { AreasList, AreaDetail } from "@/pages/Areas";
import { MethodsList, MethodDetail } from "@/pages/Methods";
import { BlogList, BlogPost } from "@/pages/Blog";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import { MentionsLegales, Confidentialite } from "@/pages/Legal";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/domaines" element={<AreasList />} />
            <Route path="/domaines/:slug" element={<AreaDetail />} />
            <Route path="/methodes" element={<MethodsList />} />
            <Route path="/methodes/:slug" element={<MethodDetail />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <CookieBanner />
        <Toaster position="bottom-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
